import React, { useEffect, useState } from 'react';
import Header from './components/Header';
import MobileNav from './components/MobileNav';
import SideBar from './components/SideBar';
import Placeholder from '../../assets/img/product.jpg';
import { FormControl, MenuItem, Select } from '@mui/material';
import Message from '../../components/Message';
import Loader from '../../components/Loader';
import { connect, useDispatch } from 'react-redux';
import { artisanCreateProduct } from '../../redux/actions/ArtisanAction';
import { useNavigate } from 'react-router-dom';
import { ARTISAN_PRODUCT_CREATE_RESET } from '../../redux/constants/ArtisanConstants';

const ArtisanAddedProductScreen = ({ artisanProductCreate, artisanCreateProduct }) => {

    const navigate = useNavigate();
    const dispatch = useDispatch()

    const [newProduct, setNewProduct] = useState({
        image: '',
        name: '', 
        category: '',
        total_products: '',
        price: '',
        rating: '',
        description: ''
    })


    const [formError, setFormError] = useState('')


    const { loading, success, error } = artisanProductCreate;

    useEffect(() => {

        dispatch({ type: ARTISAN_PRODUCT_CREATE_RESET })

        if (success) {
            navigate('/artisan/productList')
        }

    }, [success])


    const handleProfileClick = () => {
        document.getElementById("product_image").click()
    }

    const handleProfile = e => {

        if (e.target.files[0]) {

            const reader = new FileReader();

            reader.addEventListener("load", (e) => {
                document.getElementById('placeholder').setAttribute('src', e.target.result)
            })

            reader.readAsDataURL(e.target.files[0])
        }


        setNewProduct({
            ...newProduct,
            image: e.target.files[0]
        })
    }


    const handleNumber = e => {
        const { name, value } = e.target;

        const re = /^[1-9]\d*$/

        if (value === '' || re.test(value)) {
            setNewProduct({
                ...newProduct,
                [name]: value
            })
        }
    }

    const handleProduct = e => {
        const { name, value } = e.target;

        setNewProduct({
            ...newProduct,
            [name]: value
        })

    }


    const handleSubmit = e => {
        e.preventDefault();

        if (!newProduct.image) {
            setFormError('Product image is required!')
        } else if (!newProduct.name) {
            setFormError('Product name is required!')
        } else if (!newProduct.category) {
            setFormError('Product category is required!')
        } else if (!newProduct.total_products) {
            setFormError('Number of product is required!')
        } else if (!newProduct.price) {
            setFormError('Product price is required!')
        } else if (!newProduct.rating) {
            setFormError('Product rating is required!')
        } else if (!newProduct.description) {
            setFormError('Product description is required!')
        } else {

            const formData = new FormData();
            formData.append('image', newProduct.image);
            formData.append('name', newProduct.name);
            formData.append('category', newProduct.category);
            formData.append('total_products', newProduct.total_products);
            formData.append('price', newProduct.price);
            formData.append('rating', newProduct.rating);
            formData.append('description', newProduct.description);

            artisanCreateProduct(formData)
        }
    }
    
    return (
        <div className='bg-gray-50 min-h-screen'>
                <SideBar />
                <MobileNav />
                <Header />
                <div className='md:ml-72 px-4 md:px-2'>
                    <div className='my-6 text-3xl font-bold tracking-wide uppercase md:text-center'>
                        product form
                    </div>
                    <div className='flex justify-center items-center  mx-auto my-10'>
                        <div className='w-full p-4 shadow-md rounded bg-white'>
                            <form action="" onSubmit={handleSubmit}>

                                <div className='w-full mb-8'>
                                    <div className='flex justify-center mb-4'>
                                        <img src={Placeholder} className='w-80 h-60 object-cover rounded-lg' id='placeholder' alt='placeholder' onClick={handleProfileClick} />
                                    </div>
                                    <label htmlFor="product_image" className="flex justify-center mb-2 text-sm font-medium text-gray-900">Product Image <span className='text-red-500 text-base'>*</span></label>
                                    <input
                                        type='file'
                                        name='product_image'
                                        id='product_image'
                                        accept=".png, .jpg, .jpeg"
                                        className='w-40 rounded-full'
                                        style={{ display: "none" }}
                                        onChange={handleProfile}
                                    />
                                </div>

                            {loading && <Loader />}
                            {error && <Message error msg={error} />}
                            {formError && <Message error msg={formError} />}

                                <div className='grid md:grid-cols-3 grid-cols-1 gap-4'>
                                    <div>
                                        <div className='w-full mb-6'>
                                            <label htmlFor="name" className="block mb-2 text-sm font-medium text-gray-900">Product Name <span className='text-red-500 text-base'>*</span></label>
                                            <input
                                                type='text'
                                                name='name'
                                                id='name'
                                                value={newProduct.name}
                                                onChange={handleProduct}
                                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            />
                                        </div>
                                        <div className="w-full mb-6">
                                            <FormControl className='w-full'>
                                                <label htmlFor='row-label' className="block mb-2 text-sm font-medium text-gray-900 ">Product Category <span className='text-red-500 text-base'>*</span></label>
                                                <Select
                                                    id='row-label'
                                                    name="category"
                                                    onChange={handleProduct}
                                                    className='h-10 md:w-full shadow-sm bg-gray-50  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
                                                >
                                                    <MenuItem value=''>Select Category</MenuItem>
                                                    <MenuItem value='wooden_handicrafts'>Wooden handicrafts</MenuItem>
                                                    <MenuItem value='clay_pottery'>Clay & pottery</MenuItem>
                                                    <MenuItem value='leather'>Leather</MenuItem>
                                                    <MenuItem value='jute'>Jute</MenuItem>
                                                    <MenuItem value='shell'>Shell</MenuItem>
                                                    <MenuItem value='metal_handicrafts'>Metal Handicrafts</MenuItem>
                                                    <MenuItem value='bamboo_cane'>Bamboo & Cane</MenuItem>
                                                    <MenuItem value='stone'>Stone</MenuItem>
                                                    <MenuItem value='bone_horn'>Bone & Horn</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>

                                    <div>
                                        <div className='w-full mb-6'>
                                            <label htmlFor="total_products" className="block mb-2 text-sm font-medium text-gray-900">No. of Products <span className='text-red-500 text-base'>*</span></label>
                                            <input
                                                type='text'
                                                name='total_products'
                                                id='total_products'
                                                value={newProduct.total_products}
                                                onChange={handleNumber}
                                                className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            />
                                        </div>

                                        <div className='w-full mb-6'>
                                            <label htmlFor="price" className="block mb-2 text-sm font-medium text-gray-900">Product Price <span className='text-orange-500 text-base'>Per item</span> <span className='text-red-500 text-base'>(₹)*</span></label>
                                            <input
                                                type='text'
                                                name='price'
                                                id='price'
                                                value={newProduct.price}
                                                onChange={handleNumber}
                                                className="shadow-sm bg-gray-50 border  border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                            />
                                        </div>
                                    </div>

                                    <div>
                                        <div className="w-full mb-6">
                                            <FormControl className='w-full'>
                                                <label htmlFor='row-label' className="block mb-2 text-md font-medium text-gray-900 ">Rating <span className='text-red-500 text-base'>*</span></label>
                                                <Select
                                                    id='row-label'
                                                    name='rating'
                                                    onChange={handleProduct}
                                                    className='h-10 md:w-full shadow-sm bg-gray-50  text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5'
                                                >
                                                    <MenuItem value=''>Select rating</MenuItem>
                                                    <MenuItem value='1'>1 - Poor</MenuItem>
                                                    <MenuItem value='2'>2 - Fair</MenuItem>
                                                    <MenuItem value='3'>3 - Good</MenuItem>
                                                    <MenuItem value='4'>4 - Very Good</MenuItem>
                                                    <MenuItem value='5'>5 - Excellent</MenuItem>
                                                </Select>
                                            </FormControl>
                                        </div>
                                    </div>
                                </div>

                                <div className='w-full'>
                                    <label htmlFor="description" className="block mb-2 text-sm font-medium text-gray-900">Description  <span className='text-orange-500 text-base'>(100 words)</span><span className='text-red-500 text-base'>*</span></label>
                                    <textarea
                                        type='text'
                                        name='description'
                                        id='description'
                                        value={newProduct.description}
                                        onChange={handleProduct}
                                        className="shadow-sm resize-none h-20 bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5"
                                    ></textarea>
                                </div>

                                <button type='submit' className='uppercase w-fit bg-[#34508D] hover:bg-black text-white text-sm text-center p-2.5 rounded shadow mt-8'>submit</button>
                            </form>
                        </div>
                    </div>
                </div>
        </div>
    )
}

const mapStateToProps = (state) => ({
    artisanProductCreate: state.artisanProductCreate
})

export default connect(mapStateToProps, { artisanCreateProduct })(ArtisanAddedProductScreen);